import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import Panel_1 from '../../img/decor/panel_1.png';
import Panel_2 from '../../img/decor/panel_2.png';
import Panel_3 from '../../img/decor/panel_3.png';
import Panel_4 from '../../img/decor/panel_4.png';
import Panel_5 from '../../img/decor/panel_5.png';

const panels = [Panel_1, Panel_2, Panel_3, Panel_4, Panel_5];

const EventPanelBase = ({ panelData }) => {
    if (!panelData) return null;

    const { panel_title, panel_list } = panelData;

    const panels = [Panel_1, Panel_2, Panel_3, Panel_4, Panel_5];

    return (
        <section className="mb-[60px] lg:mb-[120px]">
            <div className="container max-w-screen-xl mx-auto px-5">
                <h2 className="text-[30px] uppercase text-center font-bold xl:text-[55px] mb-10 lg:mb-16">
                    {panel_title}
                </h2>

                {panel_list.map((panel, index) => (
                    <React.Fragment key={index}>

                        <div className="bg-[#c8d2db] px-4 py-9 mb-5 lg:mb-8 md:flex md:items-start md:gap-6 lg:px-16
                            xl:gap-16">
                            {panels[index] && (
                                <img
                                    src={panels[index]}
                                    alt={`Panel ${index + 1}`}
                                    className="object-contain w-[112px] hidden md:block"
                                />
                            )}

                            <div>
                                <div className="flex items-center gap-3 mb-4">
                                    {panels[index] && (
                                        <img
                                            src={panels[index]}
                                            alt={`Panel ${index + 1}`}
                                            className="object-contain w-[50px] md:hidden"
                                        />
                                    )}
                                    <h3 className="font-bold text-lg uppercase py-1 px-3 leading-tight bg-white lg:text-2xl">{panel.title} </h3>
                                </div>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(panel.text),
                                    }}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </section>
    );
};

export default EventPanelBase;